import { render } from "./Autocomplete.vue?vue&type=template&id=f5f007ee"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__